import { Button, Grid, Link, Paper, Typography } from "@material-ui/core";
import React from "react";
import ColoredDivider from "views/ColoredDivider/ColoredDivider";
import FooterVideoPlace from "views/FooterVideoPlace/FooterVideoPlace";
import ResponsiveReactPlayer from "views/sidebar/ResponsiveReactPlayer/ResponsiveReactPlayer";

export default function Produto() {
  return (
    <div>
      <Grid container alignItems="center" justifyContent="center">
        <Grid item xs={12}>
          <ResponsiveReactPlayer
            url="https://www.youtube.com/watch?v=qA6KoyYFHTM"
            controls
            playing
            muted
            dividerUp
            dividerDown
            loop
            width="100%"
            height="60vh"
          />
        </Grid>
        <Grid item xs={8} style={{ textAlign: "center", margin: "10px" }}>
          <Typography variant="h5" color="secondary">
            Smartphone Xiaomi Redmi 9A 32GB Cinza 4G Octa-Core - 2GB RAM 6,53”
            Câm. 13MP + Selfie 5MP Dual Chip
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ColoredDivider />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper
            elevation={3}
            style={{ margin: "15px", padding: "15px", textAlign: "center" }}
          >
            <Typography variant="body1" color="secondary">
              Somente por
            </Typography>
            <Typography variant="h2" style={{ color: "#ffdd00" }}>
              R$ 1.419,99
            </Typography>
            <Typography variant="h5" color="secondary">
              Em até 10x R$ 142,08 sem juros
            </Typography>

            <Grid container alignItems="center" justifyContent="center">
              <Grid item xs={12}>
                <br />
                <Typography variant="body2" color="secondary">
                  Anunciante:
                </Typography>
                <Link
                  href="/anunciante/xiaomi"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="subtitle1">Xiaomi</Typography>
                </Link>
                <br />

                <Typography variant="body2" color="secondary">
                  Categoria:
                </Typography>
                <Link
                  href="/categoria/eletronicos"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <Typography variant="subtitle1">Eletrônicos</Typography>
                </Link>
                <br />
                <Link
                  target="_blank"
                  href="https://www.google.com.br"
                  style={{ textDecoration: "none" }}
                >
                  <Button variant="contained" color="primary" fullWidth>
                    COMPRAR AGORA
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div style={{ margin: "15px", padding: "15px" }}>
            <Typography variant="h6" color="secondary">
              Sobre esse produto:
            </Typography>
            <Typography variant="subtitle1" color="secondary">
              Pulseiras 4G LTE: 1, 2, 3, 4, 5, 7, 8, 20, 28, 38, 40, 41 |
              somente GSM Super AMOLED de 6,35 polegadas, 450 nits (tipo), 1100
              nits (pico) | Corning Gorilla Glass 3 48 MP, f/1,8, 26 mm
              (largura), 1,27 mm, 0,8 µm, PDAF | 8 MP, f/2,2, 118Ë (ultralargo),
              1/4 polegada, 1,6 polegada. 12 µm | 2 MP, f/2.4, (macro) | 2 MP,
              f/2.4, (profundidade) 64 GB de RAM | Qualcomm SDM678 Snapdragon
              678 (11 nm) | Octa-core (2 x 2,2 GHz Kryo 460 Gold e 6 x 1,7 GHz
              Kryo 460 Silver) Li-Po 5000 mAh, no removível | Carregamento
              rápido de 33 W, 50% em 25 minutos, 100% em 74 minutos Celulares
              desbloqueados de fábrica so compatíveis com a maioria das
              operadoras GSM. Esteja ciente de que no so compatíveis com
              operadoras CDMA
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12}>
          <FooterVideoPlace />
        </Grid>
      </Grid>
    </div>
  );
}
